import {UseQueryResult, useQueryClient} from '@tanstack/react-query'
import {useAsyncOnceDefined} from '@freckle/educator-entities/ts/common/hooks/use-async'
import {
  fetchClaimedFreeResourcesForCurrentWeek,
  ClaimedFreeResourcesT,
} from '@freckle/classroom/ts/common/models/claimed-free-resources'
import {useTeacher} from './use-teacher'

const QUERY_KEY = 'fetchClaimedFreeResourcesForCurrentWeek' as const

export const useClaimedFreeResourcesForCurrentWeek = (): UseQueryResult<ClaimedFreeResourcesT> => {
  const teacher = useTeacher()
  return useAsyncOnceDefined(
    ({teacher}) => fetchClaimedFreeResourcesForCurrentWeek(teacher.id),
    QUERY_KEY,
    [teacher.data?.id],
    {teacher},
    {staleTime: Infinity}
  )
}

export const useMarkClaimedFreeResourcesStale = (): (() => Promise<void>) => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({queryKey: [QUERY_KEY]})
}
